export const ACCESS_TOKEN_NAME = 'access_token';
export const OTP_TOKEN = 'otp_token';

export const setTokenToLocalStorage = (token: string): void => {
  localStorage.setItem(ACCESS_TOKEN_NAME, token);
};

export const getTokenFromLocalStorage = (): string | null => {
  return localStorage.getItem(ACCESS_TOKEN_NAME);
};

export const removeTokenFromLocalStorage = (): void => {
  localStorage.removeItem(ACCESS_TOKEN_NAME);
};

export const setOTPTokenToLocalStorage = (otpToken: string): void => {
  localStorage.setItem(OTP_TOKEN, otpToken);
};

export const getOTPTokenFromLocalStorage = (): string | null => {
  return localStorage.getItem(OTP_TOKEN);
};

export const removeOTPTokenFromLocalStorage = (): void => {
  localStorage.removeItem(OTP_TOKEN);
};
